function getRandomInt(min, max) {
  return Math.floor(Math.random() * ((max - min) + 1)) + min;
}

function shuffle(str) {
  return str.split('').sort(() => 0.5 - Math.random()).join('');
}

export function getStrongPassword() {
  const letters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
  const specialChars = ['!', '@', '#', '$', '%', '&', '*', '(', ')', ',', '.', '?', '<', '>', '=', '+', '-', '€', '_'];

  const strContent = [
    { type: 'letter', amount: 5 },
    { type: 'number', amount: 2 },
    { type: 'specialChar', amount: 1 },
  ];
  let str = '';

  strContent.forEach((content) => {
    for (let i = 0; i < content.amount; i++) {
      if (content.type === 'letter') {
        let letter = letters[getRandomInt(0, 25)];
        if (Math.random() > 0.5) {
          letter = letter.toUpperCase();
        }
        str += letter;
      }
      if (content.type === 'number') {
        str += getRandomInt(0, 9);
      }
      if (content.type === 'specialChar') {
        str += specialChars[getRandomInt(0, 18)];
      }
    }
  });
  return shuffle(str);
}
